// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"90c25f71","303":"a7d8bb17","309":"afc0a265","361":"679e6233","417":"363d42fa","606":"9c8942f8","701":"9ad72532","787":"5b459c87","862":"d173e544"}[chunkId] + ".chunk.js";
};